/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: index.ts
 * Class: index.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { GameState } from './types';
import { RootState } from '../types';
import { getDefaultState } from '../utils';

export const state: GameState = {
  game: { ...getDefaultState() },
  mods: { ...getDefaultState() },
  groupedMods: { ...getDefaultState() },
  extensions: { ...getDefaultState() },
  activeModspaceExtension: { ...getDefaultState() },
  error: false,
  worker: null,
};

const namespaced = true;

export const game: Module<GameState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
